import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { User, Intake } from "@/CodegenTypes";

import { sumBy, first, sortBy } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";
import IntakeDetailsModal from "@/components/modules/bet-details/IntakeDetailsModal.vue";
import { customMoment } from "@/main";
import { useQuery } from "@vue/apollo-composable";
import { computed, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { useRootStore } from "@/store/pinia";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntakeDetails',
  setup(__props) {

const route = useRoute();
const store = useRootStore();
const { $t } = useTranslation();


const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
});

const { result, loading } = useQuery<{ user: User }>(queries.userIntakes, {
  releaseDate: computed(() =>
    customMoment(selectedStartReleaseDate.value).startOf("day").toDate()
  ),
  userId: computed(() => store.account?.userId),
});

const selectedIntakeData = ref<null | Intake[]>(null);
const showIntakeDetailModal = ref(false);

const intakeReportData = computed(() => {
  if (!result.value?.user) {
    return [];
  }
  const users = result.value?.user.intakes.map((i) => {
    const big = sumBy(i.rows, (r) => r.big);
    const small = sumBy(i.rows, (r) => r.small);
    const turn = sumBy(i.rows, (r) => r.turn);
    const amount = big * 1.6 + small * 0.7 - turn * 0.7;
    return {
      ...i,
      big,
      small,
      turn,
      amount,
    };
  });

  const sortedData = sortBy(users, (d) => d.intakerUserId);
  return sortedData;
});

const intakeReportDataSummary = computed(() => {
  return {
    big: formatDollar(sumBy(intakeReportData.value, (d) => d.big)),
    turn: formatDollar(sumBy(intakeReportData.value, (d) => d.turn)),
    small: formatDollar(sumBy(intakeReportData.value, (d) => d.small)),
    amount: formatDollar(sumBy(intakeReportData.value, (d) => d.amount)),
  };
});

function openIntakeDetail(userId: string) {
  const selectedUser = result.value?.user?.intakes.find(
    (u) => u.intakerUserId === userId
  );
  selectedIntakeData.value = selectedUser?.rows || [];
  showIntakeDetailModal.value = true;
}

return { __sfc: true,route, store, $t, selectedStartReleaseDate, result, loading, selectedIntakeData, showIntakeDetailModal, intakeReportData, intakeReportDataSummary, openIntakeDetail, formatDollar, IntakeDetailsModal }
}

})